import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the app module.
 * @return {*}
 */
export default function useTranslationApp() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/app.json'),
    'fr': import('./locales/fr/app.json')
  }), []);

  return useModuleTranslation('app', imports);
}
